function footer(props) {
    return (
			<div className='container-fluid text-center p-3 form mt-3'>© JASI Productions 2022</div>
		);
}

export default footer;